// authSlice.js
// eslint-disable-next-line import/namespace
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  user: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      const { isAuthenticated, user } = action.payload;
      state.isAuthenticated = isAuthenticated;
      state.user = user;

    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      //localStorage.clear();

      localStorage.setItem('isHome', true);
      localStorage.removeItem('token');
      localStorage.removeItem('apid');
      localStorage.removeItem('upid');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('expirationDate');
      localStorage.removeItem('userName');
      localStorage.removeItem('name');
      localStorage.removeItem('role');
      localStorage.removeItem('email');
      localStorage.removeItem('statusCode');
      localStorage.removeItem('message');
      localStorage.removeItem('userId');
    }
  }
});

export const { login, logout } = authSlice.actions;
export const selectAuth = (state) => state.auth;
export default authSlice.reducer;
